var _rect, _path, _path2, _path3, _g, _path4, _path5, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCloud24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: -0.000732422,
  y: -0.00787354,
  width: 24,
  height: 24,
  rx: 6,
  fill: "#0059EA"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1994 15.192C19.1994 13.0946 17.4518 11.3919 15.2993 11.3919H7.49931C5.34688 11.3919 3.59937 13.0946 3.59937 15.192C3.59937 17.2892 5.34688 18.9919 7.49931 18.9919H15.2993C17.4518 18.9919 19.1994 17.2892 19.1994 15.192Z",
  fill: "#FFC531"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5992 4.99188C14.5795 4.99188 16.9992 7.41149 16.9992 10.3919C16.9992 13.3723 14.5795 15.7919 11.5992 15.7919C8.61883 15.7919 6.19922 13.3723 6.19922 10.3919C6.19922 7.41149 8.61883 4.99188 11.5992 4.99188Z",
  fill: "#FF9E00"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud_24.svg__mask0_47_16631",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 3,
  y: 11,
  width: 9,
  height: 8
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.39907 11.3918C9.49641 11.3918 11.1991 13.0946 11.1991 15.1919C11.1991 17.2891 9.49641 18.9918 7.39907 18.9918C5.30183 18.9918 3.59912 17.2891 3.59912 15.1919C3.59912 13.0946 5.30183 11.3918 7.39907 11.3918Z",
  fill: "#FFC531"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud_24.svg__mask0_47_16631)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5992 4.99176C14.5795 4.99176 16.9992 7.41137 16.9992 10.3918C16.9992 13.3722 14.5795 15.7918 11.5992 15.7918C8.61883 15.7918 6.19922 13.3722 6.19922 10.3918C6.19922 7.41137 8.61883 4.99176 11.5992 4.99176Z",
  fill: "#FFCF38"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1993 8.19183C18.1797 8.19183 20.5993 10.6115 20.5993 13.5918C20.5993 16.5722 18.1797 18.9918 15.1993 18.9918C12.219 18.9918 9.79932 16.5722 9.79932 13.5918C9.79932 10.6115 12.219 8.19183 15.1993 8.19183Z",
  fill: "#FF6331"
})), /*#__PURE__*/React.createElement("mask", {
  id: "svg-public/img/icons/cloud_24.svg__mask1_47_16631",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 9,
  y: 8,
  width: 12,
  height: 11
}, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.1993 8.19177C18.1797 8.19177 20.5993 10.6114 20.5993 13.5917C20.5993 16.5721 18.1797 18.9918 15.1993 18.9918C12.219 18.9918 9.79932 16.5721 9.79932 13.5917C9.79932 10.6114 12.219 8.19177 15.1993 8.19177Z",
  fill: "#FF6331"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#svg-public/img/icons/cloud_24.svg__mask1_47_16631)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5992 4.99194C14.5795 4.99194 16.9992 7.41155 16.9992 10.3919C16.9992 13.3723 14.5795 15.7919 11.5992 15.7919C8.61883 15.7919 6.19922 13.3723 6.19922 10.3919C6.19922 7.41155 8.61883 4.99194 11.5992 4.99194Z",
  fill: "#FF6331"
}))));
export { SvgCloud24 as ReactComponent };